'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _DTBButtonContainer = require('pricing-pages-unified-ui/components/public-only/DTBButtonContainer');

var _DTBButtonContainer2 = _interopRequireDefault(_DTBButtonContainer);

var _TalkToSalesButton = require('pricing-pages-unified-ui/components/public-only/TalkToSalesButton');

var _TalkToSalesButton2 = _interopRequireDefault(_TalkToSalesButton);

var _nonMerchandiseIdProductPropInterface = require('pricing-pages-unified-ui/utils/nonMerchandiseIdProductPropInterface');

var _nonMerchandiseIdProductPropInterface2 = _interopRequireDefault(_nonMerchandiseIdProductPropInterface);

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  This component fully encapsulates purchase motion logic
  for the public site.
*/
var PublicPurchaseMotionButton = function PublicPurchaseMotionButton(props) {
  var sourceId = props.sourceId,
      merchandiseId = props.merchandiseId,
      eligiblePromotion = props.eligiblePromotion,
      nonMerchandiseIdProduct = props.nonMerchandiseIdProduct;


  if (merchandiseId && nonMerchandiseIdProduct) {
    throw new Error('Cant have both merchandiseId and nonMerchandiseIdProduct defined');
  }

  if (!merchandiseId && !nonMerchandiseIdProduct) {
    throw new Error('Need to have at least a merchandiseId or nonMerchandiseIdProduct');
  }

  // For most pages, this should be the calculator CTAs
  // weird naming due to consistency with past pricing page GA stuff
  if (sourceId === 'pricing-middle') {
    return _react2.default.createElement(_TalkToSalesButton2.default, props);
  }

  var dtbBundledOffer = (0, _publicPageUrls.getBundledOffer)(merchandiseId, eligiblePromotion, nonMerchandiseIdProduct);

  if (dtbBundledOffer) {
    return _react2.default.createElement(_DTBButtonContainer2.default, _extends({ bundledOffer: dtbBundledOffer }, props));
  }

  return _react2.default.createElement(_TalkToSalesButton2.default, props);
};

PublicPurchaseMotionButton.propTypes = _extends({
  sourceId: _react.PropTypes.string.isRequired,
  merchandiseId: _react.PropTypes.number,
  className: _react.PropTypes.string,
  use: _react.PropTypes.string
}, _nonMerchandiseIdProductPropInterface2.default);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    eligiblePromotion: (0, _PromotionSelectors.merchSpecficPromotionEligibilitySelector)(state, props.merchandiseId)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PublicPurchaseMotionButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/public-only/PublicPurchaseMotionButton.js
// module id = 234
// module chunks = 3 4